import { useEffect, useState } from "react";
import axios from "axios";
import { Rechte } from "../lib/rechte";

const API_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';

const RECHTE_GEAENDERT_EVENT = 'rechte-geaendert';

/** Nach Änderungen an Rollen/Rechten aufrufen, damit alle useRechte-Instanzen neu laden. */
export function benachrichtigeRechteAenderung(): void {
  window.dispatchEvent(new Event(RECHTE_GEAENDERT_EVENT));
}

interface RechteAntwort {
  rechte: Rechte;
  rollen: string[];
}

/** Rechte des angemeldeten Benutzers. Fail-closed: bei Fehler (und bis zum Laden)
    ist `rechte` leer, also hatRecht/darfPreise = false. */
export function useRechte(): { rechte: Rechte; rollen: string[]; geladen: boolean } {
  const [rechte, setRechte] = useState<Rechte>({});
  const [rollen, setRollen] = useState<string[]>([]);
  const [geladen, setGeladen] = useState(false);
  useEffect(() => {
    let mounted = true;
    const laden = () => {
      axios
        .get<RechteAntwort>(`${API_URL}/api/me/rechte`)
        .then((r) => {
          if (!mounted) return;
          setRechte(r.data.rechte ?? {});
          setRollen(r.data.rollen ?? []);
          setGeladen(true);
        })
        .catch(() => {
          if (!mounted) return;
          setRechte({});
          setRollen([]);
          setGeladen(true);
        });
    };
    laden();
    window.addEventListener(RECHTE_GEAENDERT_EVENT, laden);
    return () => {
      mounted = false;
      window.removeEventListener(RECHTE_GEAENDERT_EVENT, laden);
    };
  }, []);
  return { rechte, rollen, geladen };
}
